import { Conversation, Message } from '@/features/AIChat/types/chat';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { saveUserConfig, UserConfig } from '@/slices/userConfigSlice';

const MAX_HISTORY = 10;

export const deriveConversationName = (messages: Message[]) => {
  const firstHuman = messages.find(m => m.sender === 'human') as
    | (Message & { sender: 'human'; text: string })
    | undefined;
  const text = (firstHuman?.text || '').trim();
  if (!text) return '...';
  return text;
};

export default function saveUserHistory(
  userConfig: UserConfig,
  dispatch: ReturnType<typeof useAppDispatch>,
  updatedConversation: Conversation,
  existing: Conversation[],
  idx: number
) {
  const ensuredName =
    updatedConversation.name ?? deriveConversationName(updatedConversation.messages);

  const withName: Conversation = { ...updatedConversation, name: ensuredName };

  const chatHistory =
    idx >= 0
      ? [...existing.slice(0, idx), withName, ...existing.slice(idx + 1)]
      : [withName, ...existing];
  const limited = chatHistory.slice(0, MAX_HISTORY);
  dispatch(
    saveUserConfig({
      userConfig: {
        ...userConfig,
        chatHistory: limited
      }
    })
  );
}
